"use strict";
/**
 * Internal Fields — fields stripped by sanitizeResponse before API responses
 *
 * This is the single source of truth for all internal/security fields.
 * The runtime array (INTERNAL_FIELD_NAMES) and compile-time union (InternalFields)
 * are kept in sync via `as const` + indexed access.
 *
 * Consumed by:
 * - shared-types (SanitizedRecord<T> utility, derived API types)
 * - lambda-utilities (sanitizeResponse runtime stripping)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_FIELD_NAMES = void 0;
/**
 * Runtime array of all internal field names stripped by sanitizeResponse.
 * Covers DynamoDB keys, scanning metadata, internal state, moderation metadata,
 * TTL/tracking, and security-sensitive fields.
 */
exports.INTERNAL_FIELD_NAMES = [
    // DynamoDB keys
    'PK',
    'SK',
    'GSI1PK',
    'GSI1SK',
    'GSI2PK',
    'GSI2SK',
    'GSI3PK',
    'GSI3SK',
    'GSI4PK',
    'GSI4SK',
    'GSIuPK',
    'GSIuSK',
    // Scanning metadata
    'last_scanned_at',
    'scanner_version',
    'scan_result',
    'scan_details',
    'optimization_used',
    'optimization_type',
    // Internal state
    'actionable_state',
    'superseded_by_snapshot_id',
    'is_stale',
    'stale_reason',
    // Moderation metadata
    'moderation_notes',
    'moderator_id',
    'resolved_by',
    'resolved_at',
    'force_manual_review',
    'auto_reject_count',
    // TTL and tracking
    'ttl',
    'expires_at',
    'created_by_system',
    'migration_id',
    // Security-sensitive
    'scan_provenance',
    'false_positive_count',
    'false_negative_count',
    'abuse_score',
    'submission_count',
    'block_reason',
    'blocked_until',
];
